/** Distance between two vector2's. */
export function distanceToVector2(pointA: DOMPoint, pointB: DOMPoint) {
  const dx = pointA.x - pointB.x;
  const dy = pointA.y - pointB.y;

  return Math.sqrt(dx * dx + dy * dy);
}
